import React from 'react'

export const ThemeContext = React.createContext({
  theme: 'light' as string,
  setTheme: (value: 'light' | 'dark') => {
    return value
  },
})
